import { ChevronDown } from 'lucide-react';
import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export default function NcfStatusFilter({ statuses, selected, onChange, compact = false }) {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({});
  const detailsRef = useRef(null);
  const summaryRef = useRef(null);
  const menuRef = useRef(null);
  useLayoutEffect(() => {
    if (!open) return undefined;
    const reposition = () => {
      const rect = summaryRef.current.getBoundingClientRect();
      const width = Math.min(Math.max(rect.width, 180), window.innerWidth - 16);
      const below = window.innerHeight - rect.bottom - 12;
      const above = below < 180 && rect.top > below;
      setPosition({ position: 'fixed', left: Math.max(8, Math.min(rect.left, window.innerWidth - width - 8)), width,
        top: above ? undefined : rect.bottom + 4, bottom: above ? window.innerHeight - rect.top + 4 : undefined,
        maxHeight: Math.max(80, Math.min(300, above ? rect.top - 12 : below)) });
    };
    const closeOutside = event => {
      if (!detailsRef.current.contains(event.target) && !menuRef.current?.contains(event.target)) detailsRef.current.open = false;
    };
    const closeOnEscape = event => { if (event.key === 'Escape') { detailsRef.current.open = false; summaryRef.current.focus(); } };
    reposition();
    window.addEventListener('resize', reposition);
    window.addEventListener('scroll', reposition, true);
    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      window.removeEventListener('resize', reposition);
      window.removeEventListener('scroll', reposition, true);
      document.removeEventListener('pointerdown', closeOutside);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);
  const codes = statuses.map(status => status.code);
  const selection = selected ?? codes;
  const allSelected = codes.length > 0 && codes.every(code => selection.includes(code));
  const labels = selection.map(code => statuses.find(status => status.code === code)?.name || code);
  const toggle = code => onChange(selection.includes(code) ? selection.filter(value => value !== code) : [...selection, code]);
  return <div className={`ncf-status-filter${compact ? ' is-compact' : ''}`}>
    {!compact && <span>Status</span>}
    <details ref={detailsRef} className="ncf-status-multiselect" onToggle={event => setOpen(event.currentTarget.open)}>
      <summary ref={summaryRef} aria-label="Filter by status"><span>{allSelected ? 'All statuses' : labels.length === 0 ? 'No statuses selected' : labels.length <= 2 ? labels.join(', ') : `${labels.length} statuses selected`}</span><ChevronDown size={16} aria-hidden="true" /></summary>
    </details>
    {open && createPortal(<fieldset ref={menuRef} className="ncf-status-options" style={position}>
        <legend>Statuses</legend>
        <label><input type="checkbox" checked={allSelected} onChange={event => onChange(event.target.checked ? codes : [])} />All statuses</label>
        {statuses.map(status => <label key={status.code}><input type="checkbox" checked={selection.includes(status.code)} onChange={() => toggle(status.code)} />{status.name}</label>)}
      </fieldset>, document.body)}
  </div>;
}